
import axios from 'axios';
import { requestInter, responseInter } from './requestInter';
let type = process.env.VUE_APP_ENV;
let token = localStorage.getItem('token') || '';
let fetch = axios.create({
    baseURL:  '/auth',
    headers: {
        'Authorization':'bearer' +token,
    },
    withCredentials:true,

});
requestInter(fetch);
responseInter(fetch);
export default fetch;